var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAnyMentalCheck && !_vm.isEnterprise)?_c('hover-link-card',{staticClass:"primary",attrs:{"title":"▷メンタルチェック","subtitle":"実施可能なメンタルチェックがあります。メンタルチェックは、より最適な振動を提供するために活用されます。","to":"/mypage/mentalcheck"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }